// import dynamic from 'next/dynamic';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslation } from '../util/next';
import VideoTopBanner from '../modules/VideoTopBanner';

import { initSmartSiteData } from '../api/smartApi';
import { getPageContent } from '../api/pagesApi';
import { catLog } from '../util/Cat';

import { SmartPageContainer } from '../components/SmartPageContainer';
import { useConfigShare } from '../components/Share/use-config-share';

import NewsFooter from '../modules/NewsFooter';
import { BreakPoint, useScreenSize } from '../components/ScreenSize';

const CsrPage: FC = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { screen } = useScreenSize();
  const isMobile = screen === BreakPoint.md || screen === BreakPoint.sm;
  const { shareContent = {} } = pageContentData || {};
  const description = shareContent.shareDetail || '美团社会责任';
  const title = shareContent.shareTitle || '美团社会责任';
  const pageUrl = '/csr/home/meituan';

  const { t } = useTranslation('csrhome');
  const videoTitle = t('csrVideoTitle', { returnObjects: true });
  const videoUrl = t('csrVideoUrl');
  const videoPoster = t('csrVideoPoster');
  const h5VideoPoster = t('h5CsrVideoPoster');
  const videoPlayText = t('csrVideoPlayText');
  const poster = t('poster');

  const videoTitleT = useMemo(() => {
    if (!isMobile) {
      const newTitle = videoTitle.slice(0);
      // @ts-ignore
      newTitle[0] += '，';
      return newTitle;
    }
    return videoTitle;
  }, [isMobile, videoTitle]);

  const videoCoverImg = useMemo(() => {
    return isMobile ? h5VideoPoster : videoPoster;
  }, [isMobile, h5VideoPoster, videoPoster]);

  useConfigShare({
    title,
    desc: description,
    image: '',
  });

  return (
    <section>
      <VideoTopBanner
        videoPlayText={videoPlayText}
        videoTitle={videoTitleT}
        videoLink={videoUrl}
        videoCoverImg={videoCoverImg}
        loop={false}
        poster={poster}
      />
      <SmartPageContainer title={title} description={description} pageUrl={pageUrl} {...props} />
      <div className="bg-white lg:px-5">
        <NewsFooter category={1} lanType={i18n.initialLocale} positionNo="csr_1" />
      </div>
    </section>
  );
};
export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/csr',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const catlog = catLog('PageServer', '/csr');
  let pageContentData;
  let __smart;
  try {
    pageContentData = await getPageContent(pageContentParams, locale);
    __smart = await initSmartSiteData(locale);
    catlog.complete();
  } catch (e: any) {
    catlog.logError('serverRequestError', e);
    catlog.complete();
    throw e;
  }
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_37rfzy9s',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...__smart,
      ...(await serverSideTranslation(locale, ['csrhome', 'cookie', 'common'])),
    },
  };
}
export default CsrPage;
